import {utils} from '@api'
import * as _ from 'lodash'
import {nav, site} from '@stores'
import { action, computed, observable, runInAction } from 'mobx';

export class LibraryStore {
  @observable uploadingDrop: boolean = false
  @observable uploadingMessage: string = null
  @observable showCreateSpeicificationWithImage = true
  @observable specSidebarUpdated: boolean = false

  routeFor = (library, cardView: string = undefined, view: string = 'card', libraryTab: string = 'seasonal-library') => {
    let route: any   = {
      queryParams: {
        library,
        libraryTab,
        view:     view,
        cardView: cardView,
        //specZoom: stores.specDashboard ? stores.specDashboard.cardSize.zoom: undefined
      },
      verb:        'push'
    }

    return route
  }

  @action onClickLibrary = (type, cardView, view: string = 'card', libraryTab: string = 'seasonal-library') => {
    nav.routeTo(this.routeFor(type, cardView, view, libraryTab))
  }


  @action createSpecificationWithImage = async (files: Partial<FileList>, props: Object, title: string, createInSeason = true) => {
    // this.uploadingDrop = true
    // this.uploadingMessage = `Creating ${title}...`
    // const { selectedLibrary } = this
    // const {
    //   match: {
    //     params: {
    //       season,
    //       category1,
    //       category2
    //     }
    //   }
    // } = nav
    // let specInput: any = {
    //   specCreateCount: files.length
    // }
    // if (createInSeason) {
    //   if (category1) {
    //     specInput.category1 = {id: category1}
    //   }
    //   if (category2) {
    //     specInput.category2 = {id: category2}
    //   }
    //   if (season) {
    //     specInput.season = {id: season}
    //   }
    // }
    //
    // if (selectedLibrary === 'materials') {
    //   specInput.type = 'Fabric'
    // } else if (selectedLibrary === 'hardware') {
    //   specInput.type = 'Hardware'
    // }
    // specMappings[selectedLibrary].bulkCreate.call({
    //   variables: {
    //     input: specInput
    //   }
    // }, props).then((res) => {
    //   const data = res.data[specMappings[selectedLibrary].bulkCreate.name]
    //   if (data && data.length) {
    //     this.uploadingMessage = `Uploading image(s)...`
    //     const PromiseAll = utils.resolveImages(files, 0, false)
    //     return Promise.all(PromiseAll).then((response: any) => {
    //       return utils.uploadImages(response)
    //     }).then(results => {
    //       return Promise.all(_.map(results, (result, index) => {
    //         return specMappings[selectedLibrary].updateImages.call({
    //           variables: {
    //             input: {
    //               images: [result.id],
    //               ...(createInSeason ? {
    //                 seasonId:    season,
    //                 category1Id: category1,
    //                 category2Id: category2
    //               } : {}),
    //             },
    //             where: {
    //               id: data[index]['id']
    //             }
    //           }
    //         }, props)
    //       }))
    //     }).then(() => {
    //       this.resetMassSpecificationImageCreate()
    //     }).catch((error) => {
    //       console.log('Error in updating images', error)
    //       this.resetMassSpecificationImageCreate()
    //     })
    //   }
    // })
  }

  @action resetMassSpecificationImageCreate = () => {
    this.uploadingDrop = false
    this.uploadingMessage = null
  }
}








// WEBPACK FOOTER //
// ./src/modules/libraries/stores/LibraryStore.ts